import { render } from "./GoogleClassroomCourseItem.vue?vue&type=template&id=bed427d4&ts=true"
import script from "./GoogleClassroomCourseItem.vue?vue&type=script&lang=ts"
export * from "./GoogleClassroomCourseItem.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__